import React from "react";

import { ProgressSpinner } from "primereact/progressspinner";

import BackButtom from "../../../components/backButton";
import PlanCardMobile from "./plan-card-mobile";
import PlanComparison from "./plan-comparison";

import * as S from "./styles";

import IProps from "./props";

import { planData } from "./utils/plan-data";

const Plan: React.FC<IProps> = ({ packageList, handleSubmit }) => {
  if (!packageList) {
    return (
      <S.Container>
        <S.SpinnerWrapper>
          <ProgressSpinner />
        </S.SpinnerWrapper>
      </S.Container>
    );
  }

  return (
    <S.Container>
      <BackButtom text="Escolha seu plano" />
      <PlanComparison packageList={packageList} handleSubmit={handleSubmit} />
      <S.MobileGrid>
        {planData.map((plan, index) => (
          <PlanCardMobile
            key={index}
            plan={plan}
            index={index}
            onSubmit={() => handleSubmit(packageList[index])}
          />
        ))}
      </S.MobileGrid>
    </S.Container>
  );
};

export default Plan;
